module.exports = __webpack_public_path__ + "static/media/dawulunshan1.96eb9fea.webp";